/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { Layout, Menu, Row, Col, Dropdown } from 'antd';
import './index.css'
import { Routes, Route, useNavigate } from 'react-router-dom'

import CompanyList from './sdk/companyList'
import DataNotification from './sdk/dataNotification'
import AppUsaage from './sdk/companyList/appUsage'
import CompanyUsage from './sdk/companyList/companyUsage';
import AuthorizationInformation from './sdk/authorizationInformation';
import TrialInformation from './sdk/trialInformation'
import APIDataNoticfication from './apiDashborad/apiDataNoticfication'
import DeveloperList from './apiDashborad/developer';
import AppTrend from './apiDashborad/developer/appTrend';
import APIAuthorizationInformation from './apiDashborad/apiAuthorizationInformation'
import APITrialInformation from './apiDashborad/apiTrialInformation'
import MyVitalsFeedbackList from './feedback/myVitalsFeedbackList';
import IGlucoFeedbackList from './feedback/iGlucoFeedbackList';
import FeedbackDetailsPage from './feedback/feedbackDetails';
import ClassificationManagemen from './feedback/classificationManagement'
import AndroidMyVitalsScoreListPage from './scoreOrComments/myVitals/android'
import IOSMyVitalsScoreListPage from './scoreOrComments/myVitals/ios'
import AndroidIGlucoScoreListPage from './scoreOrComments/iGluco/android'
import IOSIGlucoScoreListPage from './scoreOrComments/iGluco/ios'
import CommentsDetailsPage from './scoreOrComments/commentsContentData';
import ProfileSettingsPage from './settingsPage/profileSettings';
import SetPasswordPage from './settingsPage/setPassword';
import AppPushPage from './settingsPage/appPush'
import AppListPage from './myApp/appList';
import AppHistoryPage from './myApp/appHistoryList';
import { Link } from 'react-router-dom'
const { Header, Content, Sider } = Layout;

const DeveloperCenter = () => {
    const [collapsed, setCollapsed] = useState(false);
    let userName = sessionStorage.getItem("userName")
    let oldOpenKey = sessionStorage.getItem("oldOpenKey")
    let oldKey = sessionStorage.getItem("key")
    let access = JSON.parse(sessionStorage.getItem("access"))

    const [selectOpenKey, setOpenKey] = useState('sdk')
    const [selectKey, setKey] = useState('')
    const [items, setItems] = useState([{}])

    const navigate = useNavigate()
    React.useEffect(() => {
        if (access != null) {
            console.log(access)
            access.splice(access.indexOf('PROFILE'), 1)
            var list = []
            list = list.concat(access)
            list[access.length] = 'PROFILE'
            let data = [{}];
            list.map((item, index) => {
                switch (item) {
                    case 'SDK':
                        data[index] = sdkItems
                        break
                    case 'OPEN_API':
                        data[index] = apiItems
                        break
                    case 'PROFILE':
                        data[index] = settingsItems
                        break
                    case 'REVIEWS':
                        data[index] = scoreItems
                        break
                    case 'FEEDBACK':
                        data[index] = feedbackItems
                        break
                    case 'JIRA_SETTING':

                        break
                    case 'DISTRIBUTION':
                        data[index] = apkItems
                        break
                }
            })

            setItems(data)
        }

        if (oldKey != null && oldKey !== "") {
            console.log('key', oldKey)
            setKey(oldKey)
        }
        if (oldOpenKey != null && oldOpenKey !== "") {
            console.log('oldk', oldOpenKey)
            setOpenKey(oldOpenKey)
        }
    }, [])
    function onClick(e) {
        console.log(e)
        switch (e.key) {
            case 'developerCenter/dataNotification':
            case 'developerCenter/companyList':
            case 'developerCenter/authorizationInformation':
            case 'developerCenter/trialInformation':
                console.log('oldk2', 'sdk')
                sessionStorage.setItem("oldOpenKey", 'sdk')
                break
            case 'developerCenter/apiDataNoticfication':
            case 'developerCenter/developer':
            case 'developerCenter/developer/appTrend':
            case 'developerCenter/apiAuthorizationInformation':
            case 'developerCenter/apiTrialInformation':
                console.log('oldk2', 'api')
                sessionStorage.setItem("oldOpenKey", 'api')
                break
            case 'developerCenter/myVitalsFeedbackList':
            case 'developerCenter/iGlucoFeedbackList':
            case 'developerCenter/classificationManagement':
                console.log('oldk3', 'feedback')
                sessionStorage.setItem("oldOpenKey", 'feedback')
                break
            case 'developerCenter/scoreOrComments/myVitals/android':
            case 'developerCenter/scoreOrComments/myVitals/ios':
            case 'developerCenter/scoreOrComments/iGluco/android':
            case 'developerCenter/scoreOrComments/iGluco/ios':
                console.log('oldk3', 'score')
                sessionStorage.setItem("oldOpenKey", 'score')
                break
            case 'developerCenter/settings/profileSettings':
            case 'developerCenter/settings/appPush':
                console.log('oldk3', 'settings')
                sessionStorage.setItem("oldOpenKey", 'settings')
                break
        }
        console.log(e.key)
        setKey(e.key)
        sessionStorage.setItem("key", e.key)
        navigate(`/${e.key}`)
    }

    const onClickDropdown = ({ key }) => {
        console.log(key)
        switch (key) {
            case '1':
                onStartProfileSettings()
                break;
            case '2':
                onOut()
                break;
            default:
                break;
        }
    }
    function onStartProfileSettings() {
        console.log('settings', 'developerCenter/settings/profileSettings')
        sessionStorage.setItem("oldOpenKey", 'settings')
        setOpenKey('settings')
        setKey('developerCenter/settings/profileSettings')
        navigate(`/developerCenter/settings/profileSettings`)
    }
    function onOut() {
        sessionStorage.clear()
        navigate('../home')
    }
    function setSelectKey(newKey) {
        sessionStorage.setItem("key", newKey)
        setKey(newKey)
    }


    return (
        <Layout style={{ minHeight: '100vh', minWidth: '1440px', backgroudColor: '#ffffff' }}>
            {/* <Sider width={'208px'}  collapsible collapsed={collapsed} */}
            <Sider width={'208px'}
                onCollapse={(value) => setCollapsed(value)}>
                <Row style={{ height: '48px', }}>
                    <Col
                        span={8}>
                        <Link to='../home'>
                            <img src={require('../../static/img/ic-home-logo.png')} alt="logo"
                                style={{ marginTop: '16px', marginLeft: '9px' }} height={15.67} />
                        </Link>
                    </Col>
                    <Col style={{ display: !collapsed ? 'block' : 'none' }}>
                        <span style={Styles.appText}>
                            developer center
                        </span>
                    </Col>
                </Row>
                <Menu
                    defaultOpenKeys={[oldOpenKey != null ? oldOpenKey : selectOpenKey]}
                    selectedKeys={selectKey}
                    mode="inline"
                    theme="dark"
                    style={{ width: '208px', color: 'white' }}
                    items={items}
                    onClick={onClick}
                >
                </Menu>
            </Sider>
            <Layout style={{ height: '100vh', }}>
                <Header style={{ padding: 0, margin: '0px', backgroundColor: '#fff', }}>
                    <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>

                        <Row >
                            <Col >
                                <Dropdown overlay={<Menu onClick={onClickDropdown} items={item} />} placement="bottomLeft" arrow  >
                                    <img src={require('../../static/img/ic-head-portrait.png')}
                                        style={{ paddingLeft: "10px", margin: '0px', height: "24px" }} />
                                </Dropdown>

                            </Col>
                            <Col >
                                <span style={Styles.appTitleName}>{userName}</span>
                            </Col>
                        </Row>
                    </div>

                </Header>

                <Content className="layout-content" style={{ height: '100vh', overflowY: 'auto', backgroundColor: '#F0F2F5' }}>

                    <Content style={{ paddingTop: '15px', paddingBottom: '15px', paddingLeft: '24px', paddingRight: '24px' }}>
                        <Routes>
                            <Route path="/" element={< DataNotification />} />
                            <Route path="/dataNotification" element={< DataNotification setNewKey={setSelectKey} />} />

                            <Route path="/companyList" element={< CompanyList setNewKey={setSelectKey} />} />
                            <Route path="/companyList/appUsage" element={< AppUsaage setNewKey={setSelectKey} />} />
                            <Route path="/companyList/companyUsage" element={< CompanyUsage setNewKey={setSelectKey} />} />

                            <Route path="/authorizationInformation" element={< AuthorizationInformation setNewKey={setSelectKey} />} />
                            <Route path="/trialInformation" element={< TrialInformation setNewKey={setSelectKey} />} />

                            <Route path="/apiDataNoticfication" element={< APIDataNoticfication setNewKey={setSelectKey} />} />
                            <Route path="/developer" element={< DeveloperList setNewKey={setSelectKey} />} />
                            <Route path="/developer/appTrend" element={< AppTrend setNewKey={setSelectKey} />} />
                            <Route path="/apiAuthorizationInformation" element={< APIAuthorizationInformation setNewKey={setSelectKey} />} />
                            <Route path="/apiTrialInformation" element={< APITrialInformation setNewKey={setSelectKey} />} />

                            <Route path="/myVitalsFeedbackList" element={< MyVitalsFeedbackList setNewKey={setSelectKey} />} />
                            <Route path="/iGlucoFeedbackList" element={< IGlucoFeedbackList setNewKey={setSelectKey} />} />
                            <Route path="/feedbackList/feedbackDetails" element={< FeedbackDetailsPage setNewKey={setSelectKey} />} />
                            <Route path="/classificationManagement" element={< ClassificationManagemen setNewKey={setSelectKey} />} />

                            <Route path="/scoreOrComments/myVitals/android" element={< AndroidMyVitalsScoreListPage setNewKey={setSelectKey} />} />
                            <Route path="/scoreOrComments/myVitals/ios" element={< IOSMyVitalsScoreListPage setNewKey={setSelectKey} />} />
                            <Route path="/scoreOrComments/iGluco/android" element={< AndroidIGlucoScoreListPage setNewKey={setSelectKey} />} />
                            <Route path="/scoreOrComments/iGluco/ios" element={< IOSIGlucoScoreListPage setNewKey={setSelectKey} />} />
                            <Route path="/scoreOrComments/commentsContentData" element={< CommentsDetailsPage setNewKey={setSelectKey} />} />

                            <Route path="/settings/profileSettings" element={< ProfileSettingsPage setNewKey={setSelectKey} />} />
                            <Route path="/settings/setPassword" element={< SetPasswordPage setNewKey={setSelectKey} />} />
                            <Route path="/settings/appPush" element={< AppPushPage setNewKey={setSelectKey} />} />


                            <Route path="/apk/appList" element={< AppListPage setNewKey={setSelectKey} />} />
                            <Route path="/apk/appHistoryList" element={< AppHistoryPage setNewKey={setSelectKey} />} />

                        </Routes>
                    </Content>

                </Content>

            </Layout>
        </Layout>
    );

}
function getItem(label, key, icon, children) {
    return {
        key,
        icon,
        children,
        label,
    };
}
const sdkItems = getItem('SDK Dashboard', 'sdk', <img src={require('../../static/img/ic-sdk-bar.png')} style={{ width: '14px', height: '13px' }} />, [
    getItem('数据统计', 'developerCenter/dataNotification',),
    getItem('公司列表', 'developerCenter/companyList',),
    getItem('授权信息', 'developerCenter/authorizationInformation'),
    getItem('试用信息', 'developerCenter/trialInformation'),
]);

const apiItems = getItem('API Dashboard', 'api', <img src={require('../../static/img/ic-api-bar.png')} style={{ width: '14px', height: '13px' }} />, [
    getItem('数据统计', 'developerCenter/apiDataNoticfication',),
    getItem('开发者信息', 'developerCenter/developer'),
    getItem('授权信息', 'developerCenter/apiAuthorizationInformation'),
    getItem('试用信息', 'developerCenter/apiTrialInformation'),
]);
const feedbackItems = getItem('Feedback', 'feedback', <img src={require('../../static/img/ic-feedback-bar.png')} style={{ width: '14px', height: '13px' }} />, [
    getItem('反馈列表 MyVitals', 'developerCenter/myVitalsFeedbackList',),
    getItem('反馈列表 IGluco', 'developerCenter/iGlucoFeedbackList',),
    getItem('分类管理', 'developerCenter/classificationManagement',),
]);
const scoreItems = getItem('Ratings & Reviews', 'score', <img src={require('../../static/img/icon-score.png')} style={{ width: '14px', height: '13px' }} />, [
    getItem('MyVitals 4.0 Android', 'developerCenter/scoreOrComments/myVitals/android',),
    getItem('MyVitals 4.0 iOS', 'developerCenter/scoreOrComments/myVitals/ios',),
    getItem('iGluco Android', 'developerCenter/scoreOrComments/iGluco/android',),
    getItem('iGluco iOS', 'developerCenter/scoreOrComments/iGluco/ios',),
]);
const apkItems = getItem('App Distribution', 'apk', <img src={require('../../static/img/icon-settings.png')} style={{ width: '14px', height: '13px' }} />, [
    getItem('App List', 'developerCenter/apk/appList',),
]);
const settingsItems = getItem('Settings', 'settings', <img src={require('../../static/img/icon-settings.png')} style={{ width: '14px', height: '13px' }} />, [
    getItem('Profile Settings', 'developerCenter/settings/profileSettings',),
    getItem('App Push', 'developerCenter/settings/appPush',),
]);
const item = [
    {
        key: '1',
        label: (
            <a target="_blank" rel="noopener noreferrer">
                Settings
            </a>
        ),
    }, {
        key: '2',
        label: (
            <a target="_blank" rel="noopener noreferrer">
                退出
            </a>
        ),
    },]
const Styles = {
    appText: {
        marginTop: '19px',
        marginLeft: '5px',
        display: 'block',
        fontSize: '15px',
        lineHeight: '10px',
        color: '#fff'
    }, appTitleName: {
        height: '22px',
        fontSize: '14px',
        marginRight: '68px',
        marginLeft: '8px',
    },
}
export default DeveloperCenter;